module.exports = __webpack_public_path__ + "source/img/thumb-down-line.13e54371.svg";